import {
  FETCH_EMPLOYEE_REQUEST,
  FETCH_EMPLOYEE_SUCCESS,
  FETCH_EMPLOYEE_FAILURE,
  FETCH_EMPLOYEE_DETAILS_REQUEST,
  FETCH_EMPLOYEE_DETAILS_SUCCESS,
  FETCH_EMPLOYEE_DETAILS_FAILURE,
  FETCH_EMPLOYEE_OTHER_INFO_REQUEST,
  FETCH_EMPLOYEE_OTHER_INFO_SUCCESS,
  FETCH_EMPLOYEE_OTHER_INFO_FAILURE,
  FETCH_EMPLOYEE_NO_PAY_REQUEST,
  FETCH_EMPLOYEE_NO_PAY_SUCCESS,
  FETCH_EMPLOYEE_NO_PAY_FAILURE,
  FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_REQUEST,
  FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_SUCCESS,
  FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_FAILURE,
  FETCH_CDL_ENG_REQUEST,
  FETCH_CDL_ENG_SUCCESS,
  FETCH_CDL_ENG_FAILURE,
  FETCH_CDL_SUP_REQUEST,
  FETCH_CDL_SUP_SUCCESS,
  FETCH_CDL_SUP_FAILURE,
  FETCH_EMPLOYEE_ATTENDANCE_REQUEST,
  FETCH_EMPLOYEE_ATTENDANCE_SUCCESS,
  FETCH_EMPLOYEE_ATTENDANCE_FAILURE,
} from "../constants/EmpDetailsConstants";

const initialState = {
  employeeList: [],
  employeeListLoading: false,
  employeeListError: null,

  employeeDetails: {},
  employeeDetailsLoading: false,
  employeeDetailsError: null,

  employeeOtherInfo: [],
  employeeOtherInfoLoading: false,
  employeeOtherInfoError: null,

  employeeNoPay: [],
  employeeNoPayLoading: false,
  employeeNoPayError: null,

  employeePreYearSummary: [],
  employeePreYearSummaryLoading: false,
  employeePreYearSummaryError: null,

  CDLEngList: [],
  CDLEngListLoading: false,
  CDLEngListError: null,

  CDLSupList: [],
  CDLSupListLoading: false,
  CDLSupListError: null,

  EmployeeAttendance: {},
  EmployeeAttendanceLoading: false,
  EmployeeAttendanceError: null,
};

export const EmployeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EMPLOYEE_REQUEST:
      return { ...state, employeeListLoading: true, employeeListError: null };
    case FETCH_EMPLOYEE_SUCCESS:
      return { ...state, employeeList: action.payload || [], employeeListLoading: false };
    case FETCH_EMPLOYEE_FAILURE:
      return { ...state, employeeListError: action.payload, employeeListLoading: false };

    case FETCH_EMPLOYEE_DETAILS_REQUEST:
      return { ...state, employeeDetailsLoading: true, employeeDetailsError: null };
    case FETCH_EMPLOYEE_DETAILS_SUCCESS:
      return { ...state, employeeDetails: action.payload || {}, employeeDetailsLoading: false };
    case FETCH_EMPLOYEE_DETAILS_FAILURE:
      return { ...state, employeeDetailsError: action.payload, employeeDetailsLoading: false };

    case FETCH_EMPLOYEE_OTHER_INFO_REQUEST:
      return { ...state, employeeOtherInfoLoading: true, employeeOtherInfoError: null };
    case FETCH_EMPLOYEE_OTHER_INFO_SUCCESS:
      return { ...state, employeeOtherInfo: action.payload || [], employeeOtherInfoLoading: false };
    case FETCH_EMPLOYEE_OTHER_INFO_FAILURE:
      return { ...state, employeeOtherInfoError: action.payload, employeeOtherInfoLoading: false };

    case FETCH_EMPLOYEE_NO_PAY_REQUEST:
      return { ...state, employeeNoPayLoading: true, employeeNoPayError: null };
    case FETCH_EMPLOYEE_NO_PAY_SUCCESS:
      return { ...state, employeeNoPay: action.payload || [], employeeNoPayLoading: false };
    case FETCH_EMPLOYEE_NO_PAY_FAILURE:
      return { ...state, employeeNoPayError: action.payload, employeeNoPayLoading: false };

    case FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_REQUEST:
      return { ...state, employeePreYearSummaryLoading: true, employeePreYearSummaryError: null };
    case FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_SUCCESS:
      return { ...state, employeePreYearSummary: action.payload || [], employeePreYearSummaryLoading: false };
    case FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_FAILURE:
      return { ...state, employeePreYearSummaryError: action.payload, employeePreYearSummaryLoading: false };

    case FETCH_CDL_ENG_REQUEST:
      return { ...state, CDLEngListLoading: true, CDLEngListError: null };
    case FETCH_CDL_ENG_SUCCESS:
      return { ...state, CDLEngList: action.payload || [], CDLEngListLoading: false };
    case FETCH_CDL_ENG_FAILURE:
      return { ...state, CDLEngListError: action.payload, CDLEngListLoading: false };

    case FETCH_CDL_SUP_REQUEST:
      return { ...state, CDLSupListLoading: true, CDLSupListError: null };
    case FETCH_CDL_SUP_SUCCESS:
      return { ...state, CDLSupList: action.payload || [], CDLSupListLoading: false };
    case FETCH_CDL_SUP_FAILURE:
      return { ...state, CDLSupListError: action.payload, CDLSupListLoading: false };
    
    case FETCH_EMPLOYEE_ATTENDANCE_REQUEST:
      return { ...state, EmployeeAttendanceLoading: true, EmployeeAttendanceError: null };
    case FETCH_EMPLOYEE_ATTENDANCE_SUCCESS:
      return { ...state, EmployeeAttendance: action.payload || [], EmployeeAttendanceLoading: false };
    case FETCH_EMPLOYEE_ATTENDANCE_FAILURE:
      return { ...state, EmployeeAttendanceError: action.payload, EmployeeAttendanceLoading: false };

    default:
      return state;
  }
};